var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progressbar-wrapper"},[_c('ProgressBarDetail',{staticClass:"d-none d-md-flex"}),_c('ProgressBarBrief',{staticClass:"d-md-none"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }